import agricarbonLogoWhite from '@/assets/images/agricarbon-logo-white.png';
import agricarbonLogoBrand from '@/assets/images/agricarbon-logo.png';
import { type AdminContainerProps, type ContainerProps } from '@/components/containers/container.props';
import { AdminHeader } from '@/components/headers/headers.component';
import { StandardSideBarMenu, UserBasedSideBarMenu } from '@/components/menus/sidebar-menus.component';
import { Body4 } from '@/components/typography';
import { cn } from '@/lib/utils';
import { usePermissions } from '@/modules/Permissions/Permissions.hooks';
import { createBreadcrumbs } from '@/utils/breadcrumbs.utils';
import { PropsWithChildren } from 'react';

export const PublicRoute = ({ children }: PropsWithChildren) => {
  return (
    <div className={cn('flex flex-col w-full h-screen')}>
      <div className={cn('flex flex-row px-8 py-6 justify-between items-center bg-neutral-725')}>
        <img src={agricarbonLogoBrand} alt="Agricarbon Logo" className="h-8 object-contain" />
      </div>
      <div className={cn('h-full flex items-center justify-center')}>{children}</div>
    </div>
  );
};

export const AdminContainer = ({ title, breadcrumbData, callToAction, searchAndFilter, className, children }: AdminContainerProps) => {
  const { hasPermission } = usePermissions();
  const breadcrumbs = breadcrumbData && createBreadcrumbs(breadcrumbData, hasPermission);
  const version = import.meta.env.VITE_VERSION || '';

  return (
    <div className={cn('flex flex-row h-screen')}>
      <div className={cn('w-64 bg-brand text-neutral-0 py-8 px-5 fixed left-0 top-0 h-screen  flex flex-col')}>
        <UserBasedSideBarMenu />
        <div className="mt-auto">
          <StandardSideBarMenu />
          <div className={cn('mt-4 pt-4 border-t border-neutral-400/20 flex')}>
            <Body4 className="text-neutral-200 opacity-75">{version}</Body4>
          </div>
        </div>
      </div>
      <div className={cn('flex flex-col h-full  pt-12 px-12 w-full ml-64', className)}>
        <AdminHeader title={title} breadcrumbs={breadcrumbs} callToAction={callToAction} searchAndFilter={searchAndFilter} />
        {children}
      </div>
    </div>
  );
};

export const ReportContainer = ({ children, className }: ContainerProps) => (
  <div className={cn('w-full h-full p-12', className)}>{children}</div>
);

export const ReportPageContainer = ({
  children,
  className,
  logoUrl,
  pageNumber,
  formattedDate,
}: ContainerProps & { pageNumber?: number; formattedDate?: string }) => {
  return (
    <div className={cn('w-[794px] h-[1123px] border px-12 pt-12 pb-8 border-b-[24px] border-brand flex flex-col', className)}>
      <div className={cn('flex justify-between items-center mb-6')}>
        <img src={agricarbonLogoBrand} alt="Agricarbon Logo" className={cn('h-12 object-contain')} />
        {logoUrl && <img src={logoUrl} alt="client-logo" className={cn('h-12 object-contain')} />}
      </div>
      <div className={cn('flex-grow flex flex-col')}>{children}</div>
      <div className={cn('flex justify-between items-end pt-10')}>
        <Body4 className="text-brand">{pageNumber}</Body4>
        <Body4 className="text-brand">Farm and Fields Report</Body4>
        <Body4 className="text-brand">{formattedDate}</Body4>
      </div>
    </div>
  );
};

export const ReportCoverContainer = ({ isFrontCover, children, className, logoUrl }: ContainerProps) => (
  <div className={cn('w-[794px] h-[1123px] border px-12 pt-12 pb-8 border-b-[24px] bg-brand border-brand flex flex-col', className)}>
    {isFrontCover && (
      <div className={cn('flex justify-end items-center mb-6')}>
        {logoUrl && <img src={logoUrl} alt="client-logo" className={cn('h-12 object-contain')} />}
      </div>
    )}
    <div className={cn('flex-grow flex flex-col')}>{children}</div>
    {isFrontCover && (
      <div className={cn('flex justify-end items-end pt-10')}>
        <img src={agricarbonLogoWhite} alt="Agricarbon Logo" className={cn('h-12 object-contain')} />
      </div>
    )}
  </div>
);
